import { urlApi } from '../../config'
import { getAccessToken } from '../../auth'

export default async function discountsRequest(path = '', { method = 'GET', body } = {}) {
  try {
    const token = await getAccessToken()
    const response = await fetch(`${urlApi}/admin/discounts${path}`, {
      method,
      credentials: 'include',
      headers: {
        ...(body !== undefined && { 'Content-Type': 'application/json' }),
        ...(typeof token === 'string' && { Authorization: `Bearer ${token}` })
      },
      ...(body !== undefined && { body: JSON.stringify(body) })
    })
    const data = await response.json().catch(() => null)
    return { ok: response.ok, status: response.status, data }
  } catch (error) {
    console.error(error)
    return { ok: false, status: 0, data: null }
  }
}
